import { forwardRef, memo, useEffect, useCallback, useState } from 'react';
import { BzInputText, BzTab, BzTabs, BzToolTip } from '../../components';
import TabsMenus from './TabsMenus';
import WatchlistDropdown from './WatchlistDropdown';
import { TabsScripsList } from '../Search';
import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import { LOCAL_STORAGE_KEYS, MIN_SCRIPS_IN_WATCHLISTS, MY_HOLDINGS_WATCHLIST_NAME, ORDER_ENTRY_BUTTON_TOGGLE, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { useDispatch, useSelector } from 'react-redux';
import { toastConfig } from '../../redux/actions/toast';
import { deepClone, isUserIsAGuest, getDecryptLocalStorage, returnCountWithPad, WATCHLIST_GRID_REF } from '../../utils/global_functions';
import { updateActiveWatchlist, updateCurrentWatchlist, updateHoldingsWatchlist, updateOpenWatchlist, updatedDashboardWatchlist } from '../../redux/actions/watchlist';
import { handleModal } from '../../redux/actions/modals';
import RenameModal from './RenameModal';
import { _handleSystemDefinedWatchlist, _watchlistNameAlreadyExist } from "../../controllers";
import { getExchangeWiseScripInfo, getScripOrderInfo } from '../../redux/actions/orders';
import useAnalyticsEventTracker from '../../hooks/useAnalyticsEventTracker';

const arrWatchlistViews = [
    { id: '0', value: '0', content: 'Default view' },
    { id: '1', value: '1', content: 'Price/Volume view' },
    { id: '2', value: '2', content: 'Heatmap view' }
];

const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);

        }}
    >
        {children}
    </div>
));

const WatchlistTabs = ({
    // Ameersha N : 08-11-2023 : BT-95888 create watchlist– Issue -reordering scrips fix when filtered  – Start **Do not change the code
    filteredRows, setMenusClicked, isFilterDataPresent,
    // Ameersha N : 08-11-2023 : BT-95888 create watchlist– Issue -reordering scrips fix when filtered  – End **Do not change the code
    setIsExpanded, setIsSideBar, setIsGlobalSearch, isSelectWatchlistDropDownOpen, setIsSelectWatchlistDropDownOpen,
    setScripsSearchValue, setIsToastToggle, dontMissOrHoldingsIdCheck, setScripDetails, setActiveButtonToggleIndex, setMarket,
    handleAllFunctions, searchScripDoneClickHandler,
    setScripsAddingToast, removeScripsFromSelectedWatchlist, strSearchInputText, isSuppressMenu, setIsSuppressMenu,
    addScripsToSelectedWatchlist, scripDetails, setStrSearchInputText = () => { },
    isShowingSearchBox, setIsShowingSearchBox, tabSearchToggle, setTabSearchToggle, handleScripDetails,
    onChangeTabSearch, searchRef, className, handleSelectSpreadOrderModel,
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
    handleWatchlistViewChange, setBIsShowDeleteCheckBox, setBIsShowSortHandle, setBisReordered, strSearchScrip, ...props }) => {
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 



    const dispatch = useDispatch();
    const { watchlists, activeWatchList, openWatchlists, popoverOpen } = useSelector(state => state.watchList);
    const modals = useSelector(state => state?.modals?.modals);
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
    const strWatchlistView = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.WATCHLIST_VIEW);
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 
    const objCFT = useSelector(state => state?.auth?.objCFT);

    const handleSearchOnClose = (e, istop = true) => {
        setStrSearchInputText('')
        if (istop) {
            e.preventDefault();
            e.stopPropagation();
        }
        setIsExpanded(prev => { return { ...prev, containerLength: '0%' }; });
        setIsSideBar(false);
        setIsGlobalSearch(false);
        setScripsSearchValue('');
        if (searchRef.current) {
            searchRef.current.value = "";
        }
        handleScripDetails(); // reset if close without done
        setTabSearchToggle(null);
        setIsShowingSearchBox(false);
    };
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                if (!popoverOpen) {
                    handleSearchOnClose(event, false);
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {

            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [popoverOpen]);

    const handleTabClick = useCallback((e, objWatchlist) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(updateHoldingsWatchlist(false));
        setStrSearchInputText('')


        handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
        setTabSearchToggle(null);
        setScripDetails([]);

        handleAllFunctions('HANDLE_MANAGE_COLUMNS', objWatchlist);
        dispatch(updateActiveWatchlist({ ...objWatchlist }));
        dispatch(updatedDashboardWatchlist({ ...objWatchlist })); //Vaibhav Singh: 08-09-2023 : Update Dashboard Watchlist
        handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
        setIsSuppressMenu(true);

        let filterElment = document?.getElementById('watchlist_header_search');
        if (filterElment !== null) {
            filterElment.value = null;
        } else { }
        setIsSelectWatchlistDropDownOpen(false);
    }, [setScripDetails, setIsSuppressMenu, setIsSelectWatchlistDropDownOpen, handleAllFunctions, setTabSearchToggle, dispatch]);
    const getEvent = useAnalyticsEventTracker('WATCHLIST');
    const tabScripHandler = useCallback((e, eachWatchlist) => {
        getEvent("ADD_SCRIP_WL");
        //Ameersha N : 22-11-2023 : BT-95888 - Breeze - Create Watchlist - Start
        let filterElment = document?.getElementById('watchlist_header_search');
        if (filterElment !== null) {
            filterElment.value = null;
        } else { }
        //Ameersha N : 22-11-2023 : BT-95888 - Breeze - Create Watchlist - End
        setIsGlobalSearch(false);
        setIsExpanded(prev => { return { ...prev, containerLength: '0%' }; });
        setIsSideBar(false);
        let isWatchlistSystemDefined = _handleSystemDefinedWatchlist(activeWatchList, "ADD");
        if (!isWatchlistSystemDefined?.status) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: isWatchlistSystemDefined?.message }));
        } else {
            handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
            setTabSearchToggle(eachWatchlist.id);
        }

    }, [setTabSearchToggle, dispatch, setIsGlobalSearch, setIsSideBar, setIsExpanded, handleAllFunctions, activeWatchList]);



    // const handleMenu = (e) => {
    //     setIsSuppressMenu(curr => !curr);
    //     setIsGlobalSearch(false);
    //     setIsExpanded(prev => { return { ...prev, containerLength: '0%' }; });
    //     setIsSideBar(false);
    // };


    const handleChooseWatchlistModal = () => {

        // setIsExpanded(prev => { return { ...prev, containerLength: '75%' }; });
        setIsSideBar(false);
        setIsGlobalSearch(false);
        handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
        if (openWatchlists.length === watchlists.length) {
            handleAllFunctions('HANDLE_CREATE_NEWWATCHLIST_OPTION');
        } else {
            dispatch(handleModal([{ 'CHOOSE_WATCHLIST_MODAL': true }]));
        }
        setTabSearchToggle(null);
    };



    //Ameersha N -12-12-2023 - BREEZE - BT-95888 -Create Watchlist -Start
    const closeWatchlistTab = useCallback((objWatchlist, e) => {
        e.preventDefault();
        if (openWatchlists?.length >= 2) {
            if (objWatchlist?.sWatchListName?.toLowerCase() === MY_HOLDINGS_WATCHLIST_NAME?.toLowerCase()) {
                setTimeout(() => {
                    dispatch(updateHoldingsWatchlist(false));
                }, 100);

            } else { }
            setIsExpanded(prev => { return { ...prev, containerLength: '0%' }; });
            setIsSideBar(false);
            setIsGlobalSearch(false);
            let arrOpenWatchlists = deepClone(openWatchlists);
            let objActiveWatchList = deepClone(activeWatchList);

            const nIndexOfObj = arrOpenWatchlists.findIndex(obj => {
                return obj.id === objWatchlist?.id;
            });

            if (arrOpenWatchlists.length > MIN_SCRIPS_IN_WATCHLISTS) {
                let filterElment = document?.getElementById('watchlist_header_search');
                if (filterElment !== null) {
                    filterElment.value = null;

                } else { }

                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                if (nIndexOfObj >= 0) {
                    if (objWatchlist.id === objActiveWatchList.id) {
                        if (arrOpenWatchlists.length - 1 === nIndexOfObj) {
                            objActiveWatchList = arrOpenWatchlists[nIndexOfObj - 1];
                            arrOpenWatchlists.splice(nIndexOfObj, 1);
                            dispatch(updateOpenWatchlist([...arrOpenWatchlists])).then(() => {
                                handleAllFunctions('HANDLE_MANAGE_COLUMNS', objActiveWatchList);
                                dispatch(updateActiveWatchlist({ ...objActiveWatchList }));
                                dispatch(updatedDashboardWatchlist({ ...objActiveWatchList })); //Vaibhav Singh: 08-09-2023 : Update Dashboard Watchlist
                            });
                            setIsSuppressMenu(true);

                        } else {
                            objActiveWatchList = arrOpenWatchlists[nIndexOfObj + 1];
                            arrOpenWatchlists.splice(nIndexOfObj, 1);
                            dispatch(updateOpenWatchlist([...arrOpenWatchlists])).then(() => {
                                handleAllFunctions('HANDLE_MANAGE_COLUMNS', objActiveWatchList);
                                dispatch(updateActiveWatchlist({ ...objActiveWatchList }));
                                dispatch(updatedDashboardWatchlist({ ...objActiveWatchList }));
                            });
                            setIsSuppressMenu(true);

                        }
                    } else {
                        arrOpenWatchlists.splice(nIndexOfObj, 1);
                        dispatch(updateOpenWatchlist([...arrOpenWatchlists])).then(() => {
                            handleAllFunctions('HANDLE_MANAGE_COLUMNS', objActiveWatchList);
                            dispatch(updateActiveWatchlist({ ...objActiveWatchList }));
                            dispatch(updatedDashboardWatchlist({ ...objActiveWatchList }));
                        });
                        setIsSuppressMenu(true);
                    }
                } else { }
            } else {

            }
            handleAllFunctions('HANDLE_MANAGE_COLUMNS', objWatchlist);
            handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
        }

    }, [handleAllFunctions, dispatch, setIsGlobalSearch, setIsSideBar, setIsExpanded,
        setIsSuppressMenu, openWatchlists, activeWatchList]);
    //Ameersha N -12-12-2023 - BREEZE - BT-95888 -Create Watchlist -End


    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - Start
    const [renamedWatchlistName, setRenamedWatchlistName] = useState('');

    const handleChange = (event) => {
        const { value } = event.target;

        const alphaNumericCharacters = /^[a-zA-Z0-9]*$/;
        if (alphaNumericCharacters.test(value)) {
            setRenamedWatchlistName(value);
        }

    };



    const cancelReanmingModal = useCallback(() => {
        dispatch(handleModal([{ 'RENAME_MODAL': false }]));
        setRenamedWatchlistName('');
    }, [dispatch]);

    // Ameersha N : 07-11-2023 : BT-95888 create watchlist [local search feature] – Issue - addedScrips state not getting empty  – Start
    const handlePlaceOrder = useCallback((orderInfo, nIsBuyOrSell) => {
        dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeId: orderInfo[WATCHLIST_GRID_INDEX.EXCHANGE], scripData: orderInfo }));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }]));
    }, [dispatch]);
    // Ameersha N : 07-11-2023 : BT-95888 create watchlist [local search feature] – Issue - addedScrips state not getting empty  – Start

    // Ameersha N : 07-11-2023 : BT-95888 create watchlist [local search feature] – Issue - addedScrips state not getting empty  – Start
    const onBuySellClick = useCallback((strBuySell, arrRowData) => {
        if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            if (arrRowData[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {
                //BT-135024 : Regression - Bug Fixing - Global Search -  : ManasaB : 14-05-2024 - Start
                if (objCFT?.MULTILEG) {
                    handleSelectSpreadOrderModel(arrRowData, strBuySell);//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
                }
                else {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `Currently you are not allowed to place orders in Multileg .` }));
                }
                //BT-135024 : Regression - Bug Fixing - Global Search -  : ManasaB : 14-05-2024 - End
            } else {
                handlePlaceOrder(arrRowData, strBuySell.toUpperCase() === 'BUY' ? ORDER_ENTRY_BUTTON_TOGGLE.BUY : ORDER_ENTRY_BUTTON_TOGGLE.SELL);
                setMarket(arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]);
                dispatch(getExchangeWiseScripInfo(arrRowData));
            }
            setIsExpanded(prev => { return { ...prev, containerLength: '0%' }; });
            setIsSideBar(false);
            setIsGlobalSearch(false);
            setScripsSearchValue('');
            searchRef.current.value = "";
            handleScripDetails(); // reset if close without done
            setTabSearchToggle(null);
            setIsShowingSearchBox(false);
        } else { }//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End

    }, [handlePlaceOrder, handleSelectSpreadOrderModel, handleScripDetails, setMarket, setIsExpanded, dispatch, searchRef, setIsGlobalSearch, setIsShowingSearchBox, setIsSideBar, setScripsSearchValue, setTabSearchToggle]);
    // Ameersha N : 07-11-2023 : BT-95888 create watchlist [local search feature] – Issue - addedScrips state not getting empty  – End

    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - Start
    const onRenameWatchlist = useCallback((renamedWatchlist) => {
        let objExistingWatchlist = _watchlistNameAlreadyExist(watchlists, renamedWatchlist);
        if (!objExistingWatchlist?.status) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: objExistingWatchlist?.message }));
        } else {
            const activeWatchlistCopy = deepClone(activeWatchList);
            activeWatchlistCopy.sWatchListName = renamedWatchlist?.toUpperCase();
            let arrScrips = activeWatchlistCopy?.scrips?.map((scrip, i) => ({
                nMarketSegmentId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                nToken: scrip[WATCHLIST_GRID_INDEX.TOKEN],
                nSequenceNo: i + 1,
                sSettings: null
            }));
            activeWatchlistCopy['scrips'] = arrScrips;

            dispatch(updateCurrentWatchlist(activeWatchlistCopy, true)).then(() => {
                cancelReanmingModal();
                setRenamedWatchlistName('');
                dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Watchlist renamed successfully' }));
            });
        }
    }, [activeWatchList, cancelReanmingModal, dispatch, watchlists]);
    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - End

    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - Start
    const handleKeyUp = (event) => {
        if (event?.keyCode === 37) {
            event?.preventDefault();
            const currentPosition = searchRef?.current?.selectionStart;
            searchRef?.current?.setSelectionRange(currentPosition - 1, currentPosition - 1);
        } else if (event?.keyCode === 39) {
            event?.preventDefault();
            const currentPosition = searchRef?.current?.selectionStart;
            searchRef?.current?.setSelectionRange(currentPosition + 1, currentPosition + 1);

        } else {

        }
    };
    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - End

    //Ameersha N : 25-09-2023 : BT-95888 - Breeze - Create Watchlist  - Start
    const handleSetShowOnLocalSearch = useCallback(() => {
        setScripsSearchValue('');
        searchRef.current.value = "";
        setTabSearchToggle(null);
        setIsShowingSearchBox(false);
    }, [searchRef, setIsShowingSearchBox, setScripsSearchValue, setTabSearchToggle]);
    //Ameersha N : 25-09-2023 : BT-95888 - Breeze - Create Watchlist - End
    const [draggedIndex, setDraggedIndex] = useState(null);

    const handleDragStart = useCallback((e, index, node) => {
        if (openWatchlists?.length > 1) {
            setDraggedIndex(index);
        }
    }, [openWatchlists]);

    const handleDragOver = (e, index) => {
        e.preventDefault();
    };

    const handleDrop = useCallback((e, index) => {
        e.preventDefault();
        if (draggedIndex !== null && draggedIndex !== index) {
            const newNodes = [...openWatchlists];
            newNodes.splice(index, 0, newNodes.splice(draggedIndex, 1)[0]);
            dispatch(updateOpenWatchlist([...newNodes]));
        }
        setDraggedIndex(null);
    }, [draggedIndex, openWatchlists, dispatch]);

    return (
        <>
            <RenameModal show={modals['RENAME_MODAL']} renamedWatchlistName={renamedWatchlistName} handleChange={handleChange} cancelModal={cancelReanmingModal} onRenameWatchlist={onRenameWatchlist} activeWatchList={activeWatchList} />
            <div className='WatchlistTabs-wrapper watchlist-fixed'>
                <div className='background-heading bdr-btm'>
                    <BzTabs className='WatchlistTabs-wrap'>
                        {
                            openWatchlists && openWatchlists?.length > 0 ?
                                openWatchlists.map((watchlist, index) => (
                                    <BzTab isDraggble={openWatchlists?.length > 1 ? true : false} draggedIndex={draggedIndex} handleDragStart={handleDragStart} handleDragOver={handleDragOver} handleDrop={handleDrop} className='WatchlistTab' index={index} onClick={(e) => {
                                        if (activeWatchList?.id !== watchlist?.id) {
                                            handleTabClick(e, watchlist);
                                        } else { }
                                    }} tabKey={`tab${watchlist?.id}`} isActive={activeWatchList?.id === watchlist?.id}>
                                        {
                                            tabSearchToggle && tabSearchToggle === watchlist?.id ?
                                                <>
                                                    <Container fluid className='p-0'>
                                                        <Row className='g-0'>
                                                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                                                <div className='searchbox'>
                                                                    <BzInputText onClick={e => { e.stopPropagation(); }} value={strSearchInputText || ''} size='sm' type='search'
                                                                        className='font-regular scripname-searchtext bdr-none' placeholder='Add scrips to watchlist....' ref={searchRef} onChange={(e) => onChangeTabSearch(e)} onKeyUp={handleKeyUp} autoFocus />
                                                                    {strSearchInputText?.length > 2 ? <div className='clear-fixed font-medium font-size2 color-text cursor-pointer' onClick={() => { setStrSearchInputText('') }}>Clear</div> : null}
                                                                </div>
                                                            </Col>
                                                            <BzToolTip placement='top' TooltipMsg='Close Search'>
                                                                <Col md={1} className='d-flex justify-content-end align-self-center'>
                                                                    <div className='icon-14 icon-close icon-light ms-2' onClick={handleSearchOnClose}></div>
                                                                </Col>
                                                            </BzToolTip>
                                                        </Row>
                                                    </Container>
                                                    {strSearchInputText?.length > 2 ? <TabsScripsList
                                                        // Ameersha N : 07-11-2023 : BT-95888 create watchlist [local search feature] – Issue - addedScrips state not getting empty  – Start
                                                        onBuySellClick={onBuySellClick}
                                                        // Ameersha N : 07-11-2023 : BT-95888 create watchlist [local search feature] – Issue - addedScrips state not getting empty  – End
                                                        isDefaultAllTab={true} strWatchlistName={activeWatchList?.sWatchListName} strSearchInputText={strSearchInputText} setShow={handleSetShowOnLocalSearch} isSearchScrips={isShowingSearchBox} onHandleDone={searchScripDoneClickHandler}
                                                        addScrips={addScripsToSelectedWatchlist} removeScrips={removeScripsFromSelectedWatchlist} scripDetails={scripDetails} setActiveButtonToggleIndex={setActiveButtonToggleIndex} setMarket={setMarket} handleSelectSpreadOrderModel={handleSelectSpreadOrderModel} /> : null}
                                                </>
                                                :
                                                <div className='d-flex gap-2 p-t-5'>
                                                    {
                                                        activeWatchList?.id === watchlist?.id ?
                                                            <>
                                                                {/* Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start  */}
                                                                <WatchlistDropdown setBIsShowSortHandle={setBIsShowSortHandle} setBisReordered={setBisReordered} setIsExpanded={setIsExpanded} setIsSideBar={setIsSideBar} setIsGlobalSearch={setIsGlobalSearch} show={isSelectWatchlistDropDownOpen} setShow={setIsSelectWatchlistDropDownOpen} setScripDetails={setScripDetails} handleAllFunctions={handleAllFunctions} setBIsShowDeleteCheckBox={setBIsShowDeleteCheckBox}  >
                                                                    {/* Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End  */}
                                                                    <div className='d-flex align-items-center gap-2'>
                                                                        <div className={`navtitle ${activeWatchList?.id == watchlist?.id ? 'color-active-text' : ''} me-1`}>{watchlist?.sWatchListName?.length > 12 ? `${watchlist?.sWatchListName.slice(0, 12)}...` : watchlist?.sWatchListName} ({returnCountWithPad(watchlist?.scrips?.length)})</div>
                                                                        <div className={`icon-14 ${isSelectWatchlistDropDownOpen ? 'icon-arrowup' : 'icon-arrowdown'}  icon-light`} onClick={() => { setIsGlobalSearch(false); setIsSideBar(false); setIsExpanded(prev => { return { ...prev, containerLength: '0%' }; }); }} />
                                                                    </div>
                                                                </WatchlistDropdown>
                                                                <Dropdown className='me-2'>
                                                                    <Dropdown.Toggle as={CustomDropdownToggle} className='p-0 m-0'>
                                                                        <BzToolTip placement='bottom' TooltipMsg='Change View'>
                                                                            <div className='icon-14 icon-eye icon-light icon-faded' onClick={() => { setIsGlobalSearch(false); setIsSideBar(false); setIsExpanded(prev => { return { ...prev, containerLength: '0%' }; }); }}></div>
                                                                        </BzToolTip>
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        {
                                                                            arrWatchlistViews.map((eachOption) => (
                                                                                // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
                                                                                <Dropdown.Item key={eachOption.id} value={eachOption.value} onClick={handleWatchlistViewChange.bind(this, eachOption.content)}>
                                                                                    {/* Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End */}
                                                                                    <Container fluid className='p-0' >
                                                                                        <Row className='g-0' >
                                                                                            <Col md={eachOption?.shortcut ? 7 : 12} className='d-flex justify-content-between align-self-center'>
                                                                                                <div className='text-nowrap text-truncate'>{eachOption.content}</div>
                                                                                                {strWatchlistView === eachOption.content && <div className='icon-20 icon-checktick icon-primary'></div>}
                                                                                            </Col>
                                                                                            {
                                                                                                eachOption?.shortcut &&
                                                                                                <Col md={5} className='d-flex justify-content-end align-self-center'>
                                                                                                    {eachOption.shortcut}
                                                                                                </Col>
                                                                                            }
                                                                                        </Row>
                                                                                    </Container>
                                                                                </Dropdown.Item>
                                                                            ))
                                                                        }
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                                <div>
                                                                    <BzToolTip placement='bottom' TooltipMsg='Add Scrip'>
                                                                        <div onClick={(e) => { tabScripHandler(e, watchlist); }} className='icon-14 icon-add-circle-fill icon-light icon-faded me-2'></div>
                                                                    </BzToolTip>
                                                                </div>
                                                                <TabsMenus
                                                                    filteredRows={filteredRows} setMenusClicked={setMenusClicked} isFilterDataPresent={isFilterDataPresent}
                                                                    openWatchlists={openWatchlists} setIsToastToggle={setIsToastToggle} activeWatchList={activeWatchList} dontMissOrHoldingsIdCheck={dontMissOrHoldingsIdCheck} handleAllFunctions={handleAllFunctions}
                                                                    handleWatchlistViewChange={handleWatchlistViewChange} strWatchlistView={strWatchlistView} setBIsShowDeleteCheckBox={setBIsShowDeleteCheckBox} setBIsShowSortHandle={setBIsShowSortHandle} strSearchScrip={strSearchScrip}>
                                                                    <BzToolTip placement='bottom' TooltipMsg='More Options'>
                                                                        <div className='icon-14 icon-kebab icon-light icon-faded' onClick={() => { setIsGlobalSearch(false); setIsSideBar(false); setIsExpanded(prev => { return { ...prev, containerLength: '0%' }; }); }}></div>
                                                                    </BzToolTip>
                                                                </TabsMenus>
                                                            </> :
                                                            <div className={`navtitle ${activeWatchList?.id == watchlist?.id ? 'color-active-text' : ''} me-1`}>{watchlist?.sWatchListName?.length > 12 ? `${watchlist?.sWatchListName.slice(0, 12)}...` : watchlist?.sWatchListName} ({returnCountWithPad(watchlist?.scrips?.length)})</div>
                                                    }
                                                    {
                                                        openWatchlists?.length <= 1 ?
                                                            <div>
                                                                <BzToolTip TooltipMsg={`Uh Oh! looks like you're trying to close the last tab. Atleast one tab has to be kept open, please open a new tab to close this tab.`} placement='right'>
                                                                    <div onClick={closeWatchlistTab.bind(this, watchlist)} className={`icon-14 icon-close ${activeWatchList?.id == watchlist?.id ? 'icon-light icon-faded' : 'icon-grey'}`} />
                                                                </BzToolTip>
                                                            </div>
                                                            :
                                                            <div>
                                                                <BzToolTip TooltipMsg={`Close Tab`} placement='right'>
                                                                    <div onClick={closeWatchlistTab.bind(this, watchlist)} className={`icon-14 icon-close ${activeWatchList?.id == watchlist?.id ? 'icon-light icon-faded' : 'icon-grey'}`} />
                                                                </BzToolTip>
                                                            </div>
                                                    }
                                                </div>
                                        }
                                    </BzTab>
                                ))
                                : null
                        }
                        <BzToolTip placement='bottom' TooltipMsg='Add Watchlist'>
                            <div className='WatchlistTab'>
                                <div data-testid="plus" onClick={handleChooseWatchlistModal} className='icon-14 icon-add icon-dark'></div>
                            </div>
                        </BzToolTip>
                    </BzTabs>
                </div>
            </div>
        </>
    );
};

export default memo(WatchlistTabs);